import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './core/login/login.component';
import { AirportSearchComponent } from './web5010/airport-search/airport-search.component';

import { AirportBasedaircraftComponent } from './web5010/airport-basedaircraft/airport-basedaircraft.component';
import { AirportHeaderComponent } from './web5010/airport-header/airport-header.component';
import { AirportContentComponent } from './web5010/airport-content/airport-content.component';
import { AirportDashboardComponent } from './web5010/airport-dashboard/airport-dashboard.component';
import { AirportFooterComponent } from './web5010/airport-footer/airport-footer.component';
import { AirportGeneralComponent } from './web5010/airport-general/airport-general.component';
import { AirportServicesComponent } from './web5010/airport-services/airport-services.component';
import { AirportRunwayComponent } from './web5010/airport-runway/airport-runway.component';
import { AirportRemarksComponent } from './web5010/airport-remarks/airport-remarks.component';


import { HttpClientModule } from '@angular/common/http';
import { AirportGridviewComponent } from './web5010/airport-gridview/airport-gridview.component';
import { GridModule,ExcelModule } from '@progress/kendo-angular-grid';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AgmCoreModule } from '@agm/core';
import { SharedModule } from './shared/shared.module';
import { ServiceModule } from './service/service.module';
import { CoreModule } from './core/core.module';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { MenuModule } from '@progress/kendo-angular-menu';
import { AirportMenuHeaderComponent } from './web5010/airport-menu-header/airport-menu-header.component';
import { AirportScrollviewComponent } from './web5010//airport-scrollview/airport-scrollview.component';
import { jqxScrollViewModule } from 'jqwidgets-ng/jqxscrollview';
import { NavMenuComponent } from './menu/nav-menu/nav-menu.component';
import { SideMenuComponent } from './menu/side-menu/side-menu.component';
import { BreadcrumbComponent } from './menu/breadcrumb/breadcrumb.component';
import { AirportAdvancedsearchComponent } from './web5010/airport-advancedsearch/airport-advancedsearch.component';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { AirportScrollviewForMobileComponent } from './web5010/airport-scrollview-for-mobile/airport-scrollview-for-mobile.component';
import { AirportScrollviewForIpadComponent } from './web5010/airport-scrollview-for-ipad/airport-scrollview-for-ipad.component';
import {ExcelService} from './service/excel.service';

import { VersionMenuComponent } from './menu/version-menu/version-menu.component';
import { ConfigService } from './service/config.service';

export function initializeApp(config: ConfigService) {
  return () => config.loadConfig().toPromise();
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    AirportSearchComponent,

    AirportBasedaircraftComponent,
    AirportHeaderComponent,
    AirportContentComponent,
    AirportDashboardComponent,
    AirportFooterComponent,
    AirportGeneralComponent,
    AirportServicesComponent,
    AirportRunwayComponent,
    AirportRemarksComponent,
    AirportGridviewComponent,
    AirportMenuHeaderComponent,
    AirportScrollviewComponent,
    NavMenuComponent,
    SideMenuComponent,
    BreadcrumbComponent,
    AirportAdvancedsearchComponent,
    AirportScrollviewForMobileComponent,
    AirportScrollviewForIpadComponent,
    VersionMenuComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    GridModule,
    ExcelModule,
    ButtonsModule,
    BrowserAnimationsModule,
    SharedModule,
    ServiceModule,
    CoreModule,
    AgmCoreModule.forRoot({
     apiKey: 'AIzaSyC7LeacWudgu9_ZE2MlqYzo_V8u2QIQ22Q'
   }),
    LayoutModule,
    MenuModule,
    jqxScrollViewModule
  ],
  providers: [ 
    ExcelService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [ConfigService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
